import PatientRejectModal from './patient-reject-modal';

export default PatientRejectModal;
